export default "__VITE_ASSET__DnM2Qu_x__"